import { useMemo, useEffect } from 'react';
import { useLoadFavouritesQuery } from '../services/plans';
import { selectUserProfile } from '../containers/accountSlice';
import { useAppSelector } from '../hooks';
import { useDispatch } from 'react-redux';
import { favouritesSetState, selectFavourites } from '../containers/plans/planSlice';
import { getFavourites as getLocalFavourites, setFavourites as setLocalFavourites } from '../localStorage';

export const useFavourites = () => {
	const userProfile = useAppSelector(selectUserProfile);
	const dispatch = useDispatch();
	const localFavourites = useAppSelector(selectFavourites);
	
	// Load favourites from server when user is logged in
	const { data: serverFavourites = [] } = useLoadFavouritesQuery(undefined, { 
		skip: !userProfile 
	});
	
	// Load favourites from localStorage when user is not logged in
	useEffect(() => {
		if (!userProfile) {
			dispatch(favouritesSetState(getLocalFavourites()));
		}
	}, [userProfile, dispatch]);
	
	// Sync favourites to localStorage when user is not logged in
	useEffect(() => {
		if (!userProfile) {
			setLocalFavourites(localFavourites);
		}
	}, [localFavourites, userProfile]);
	
	// Use server favourites if user is logged in, otherwise use local favourites
	const favourites = userProfile ? serverFavourites : localFavourites;
	const favouriteIds = useMemo(() => new Set(favourites.map((item) => item.id)), [favourites]);
	
	return {
		favourites,
		favouriteIds,
		isLoggedIn: !!userProfile,
	};
};